//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useState } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { Container } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import SimpleBar from 'simplebar-react';
// images

// icon
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { logEvent } from '../system/firebase';
// import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import TopNav from '../topNav/TopNav';
// import Footer from '../home/subComponents/Footer';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import Article from './subComponents/Article';
import Footer from '../home/subComponents/Footer';
import { useParams } from 'react-router-dom';
import ArticleTwo from './subComponents/ArticleTwo';
import ArticleThree from './subComponents/ArticleThree';
import ArticleFour from './subComponents/ArticleFour';
import ArticleFive from './subComponents/ArticleFive';
import { PAGE_TITLE_RESOURCE_CENTER } from '../common/constants';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// fake Data: added by ansar
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: 0,
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
    },
    pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
    pageHeader: {
        maxHeight: '81px',
        // [theme.breakpoints.down('md')]: { maxHeight: '134px' }, // commented out because no more second row menu -el 20221022
        // [theme.breakpoints.down('sm')]: { maxHeight: '81px' },
    },
    pageContent: {
        flex: 1,
        overflowY: 'hidden',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    jobCenterLeft: { height: '100%', paddingTop: '25px' },
    jobCenterRight: { height: '100%', overflowY: 'hidden', flexWrap: 'unset', paddingTop: '35px', minHeight: '600px' },
    headingContainer: { textAlign: 'center', color: ' #000000', padding: '52px' },
    textColour: { color: '#111E14' },
    cardTextStyle: { padding: '10px' },
    submitButton: { textTransform: 'capitalize', padding: '17px 44px', fontSize: '18px' },
    buttonContainer: { textAlign: 'center', paddingTop: 48, paddingBottom: 131 },
    resourceCard: { maxWidth: '353px', border: '1px solid #D5D7DD', borderRadius: '8px', margin: '10px', boxSizing: 'border-box' },
    resourceCardImage: { width: '100%' },
    likesViewText: { marginLeft: '9px', marginTop: '2px' },
    likeIcon: { color: 'rgba(17, 30, 20, 0.4)' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD' },
    cardContainer: { marginTop: '60px' },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
        submitButton: { variant: 'contained', color: 'secondary' },
        cardContainer: { container: true, spacing: 5 },
        resourceCard: { item: true, md: 4 },
        likesViewContainer: { container: true, direction: 'row' },
        likesViewItem: { item: true },
        cardSection: { item: true, lg: 4, md: 4, sm: 4, xs: 4 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getLayoutComponent = adminPage => {
    switch (adminPage) {
        case '1':
            return <Article />;
        case '2':
            return <ArticleTwo />;
        case '3':
            return <ArticleThree />;
        case '4':
            return <ArticleFour />;
        case '5':
            return <ArticleFive />;

        default:
            return <Article />;
    }
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ResourceCenterLayout = props => {
    // resource center data

    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const { articleId } = useParams();
    // const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { isShowJobs } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [article, setArticle] = useState(articleId);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        switch (articleId) {
            case '1':
                setArticle('1');
                break;
            case '2':
                setArticle('2');
                break;
            case '3':
                setArticle('3');
                break;
            case '4':
                setArticle('4');
                break;
            case '5':
                setArticle('5');
                break;

            default:
                setArticle('1');
        }
    }, [articleId]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.pageContainer}>
            <AfitdPageHead title={PAGE_TITLE_RESOURCE_CENTER} />
            <Grid {...defns.pageHeader}>
                <TopNav />
            </Grid>
            <Grid {...defns.pageContent}>
                <SimpleBar style={{ height: '100%', width: '100%', flex: 1, overflowX: 'hidden' }}>
                    <Grid {...defns.tempContainer}>
                        <div {...defns.root}>
                            <Container style={{ flex: 'auto' }}>
                                {/* content section */}
                                {getLayoutComponent(article)}
                                {/* <Article /> */}
                            </Container>
                            <Footer />
                        </div>
                    </Grid>
                </SimpleBar>
            </Grid>
        </Grid>
    );
};

export default ResourceCenterLayout;
